import React, { useEffect, useState } from "react";
import { useI18n } from "../i18n";
import { publicLocationsApi as locationsApi } from "../../api";
import { MapPin, Loader2 } from "lucide-react";

export default function LocationsPage() {
  const { t } = useI18n();
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    locationsApi.list()
      .then(setLocations)
      .catch(() => setLocations([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
      <h1 className="text-3xl md:text-4xl font-extrabold tracking-tight mb-2">{t("locations.title")}</h1>
      <p className="text-gray-600 mb-8">{t("locations.subtitle")}</p>
      {loading ? (
        <div className="text-center py-12 text-gray-400 inline-flex items-center gap-2 justify-center w-full">
          <Loader2 className="animate-spin" size={18} /> Loading locations...
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {locations.map((l) => (
            <div key={l.id} className="card-soft p-6 hover:shadow-lg transition-shadow">
              <div className="location-pin mb-3"><MapPin size={22} /></div>
              <h3 className="font-bold text-lg">{l.name}</h3>
              <p className="text-sm text-gray-600 mt-1">{l.address}</p>
              <div className="mt-3 flex items-center gap-3 text-xs">
                <span className="text-red-strong">{t("locations.taxLabel")} {l.tax}%</span>
                <span className="font-semibold text-gray-700">
                  {t("locations.minLabel")} {l.minBookingDays} {l.minBookingDays === 1 ? t("locations.day") : t("locations.days")}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
